import lazyLoading from "./lazyLoading";

export default {
  name: "Candidats",
  meta: {
    icon: "fa-address-book-o",
    expanded: false,
    permissions: "list candidates"
  },

  children: [
    {
      name: "list-candidates",
      path: "/admin/candidats/liste",
      meta: {
        title: "Liste des candidats",
        label: "Candidats",
        //isAdminStaff: true,
        permissions: "list candidates"
      },
      component: lazyLoading("candidates/CandidatesList")
    },
    {
      name: "list-applications",
      path: "/admin/candidatures/liste",
      meta: {
        title: "Liste des candidatures",
        label: "Candidatures",
        //isAdminStaff: true,
        permissions: "list candidates"
      },
      component: lazyLoading("candidates/ApplicationsList")
    },
    {
      name: "list-trainees",
      path: "/admin/stagiaires/liste",
      meta: {
        title: "Liste des stagiaires",
        label: "Stagiaires",
        //isAdminStaff: true,
        permissions: "list trainees"
      },
      component: lazyLoading("candidates/TraineesList")
    },
    {
      name: "new-candidate",
      path: "/admin/candidats/ajout",
      meta: {
        title: "Nouveau candidat",
        label: "Ajouter",
        permissions: "create candidate"
        //isAdminStaff: true
      },
      component: lazyLoading("candidates/Candidate")
    },
    {
      name: "import-candidates",
      path: "/admin/candidats/import",
      meta: {
        title: "Import de candidats",
        label: "Importer",
        //isAdminStaff: true
        permissions: "import candidates"
      },
      component: lazyLoading("candidates/Import")
    },
    {
      name: "import-parcoursup-candidates",
      path: "/admin/candidats/import_parcoursup",
      meta: {
        title: "Import de ParcourSup",
        label: "Import ParcourSup",
        //isAdminStaff: true
        permissions: "import parcoursup candidates"
      },
      component: lazyLoading("candidates/ImportParcourSup")
    },
    {
      name: "notify-candidates",
      path: "/admin/candidats/messages",
      meta: {
        title: "Messagerie",
        label: "Messagerie",
        permissions: "send bulk messages"
        //isAdminStaff: true
      },
      component: lazyLoading("candidates/BulkMessages")
    },
    {
      name: "status-candidates",
      path: "/admin/candidats/statuts",
      meta: {
        title: "Liste des statuts",
        label: "Statuts"
        //isAdminStaff: true
      },
      component: lazyLoading("candidates/Status")
    }
  ]
};
